import { Component, ViewModel, View, ObservableArray } from "binder";
import { ITemplateSelector } from "../templateSelector";
import { getAsBoolean } from "../utilities";
import  { ListView } from "./list-view"

export class ListViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new ListView();
    }
    public getTypeId(): string {
        return "VM-D61D5130-8535-40A1-864B-9F63599B3C43"
    }
    public set items(v: ObservableArray<ViewModel>) { this._items = v; } public get items(): ObservableArray<ViewModel> { return this._items;} private _items: ObservableArray<ViewModel>;
    public set itemtemplateselector(v: ITemplateSelector) { this._itemtemplateselector = v; } public get itemtemplateselector(): ITemplateSelector { return this._itemtemplateselector;} private _itemtemplateselector: ITemplateSelector;
    public set templateselectorfunction(v: string) { this._templateselectorfunction = v; } public get templateselectorfunction(): string { return this._templateselectorfunction;} private _templateselectorfunction: string;
    public set importanthasselectorfunction(v: boolean) { this._importanthasselectorfunction = getAsBoolean(v); } public get importanthasselectorfunction(): boolean { return this._importanthasselectorfunction;} private _importanthasselectorfunction: boolean;
    
    
}
